(function() {

    let sizeGuideAccordionContent = document.getElementById('SizeGuideAccordionContent');

    if (sizeGuideAccordionContent && window.location.pathname.includes('/products')) {
        fetch(`${window.location.pathname}?view=size-guide`)
        .then(response => response.text())
        .then(response => {
            if (response.includes('__NO_SIZE_GUIDE_AVAILABLE__')) return;
            sizeGuideAccordionContent.innerHTML = response;
            sizeGuideAccordionContent.parentNode.classList.remove('hide');
        })
        .catch(err => {
            console.log(err);
        });
    }

}());